module.exports = __webpack_public_path__ + "static/media/internshala_logo.bafc23cf.PNG";